import { useRef, useState, useEffect } from 'react'
import { TimePicker } from '@progress/kendo-react-dateinputs'
import { Popup } from '@progress/kendo-react-popup'
import { SvgIcon } from '@progress/kendo-react-common'
import * as svgIcon from '@progress/kendo-svg-icons'
import moment from 'moment'
import './rangePickerHL.css'

/**
 * @description Selector de rango de horas en un solo input. Muestra "inicio – fin" y al hacer
 * click abre un popup con dos TimePicker (Kendo no ofrece un time-range nativo).
 * @param {{ value: {start: Date|null, end: Date|null}, onChange: Function, placeholder: String, labelStart: String, labelEnd: String }} props
 */
const RangeTimePickerHL = ({ value, onChange, placeholder = '', labelStart, labelEnd }) => {
  const anchor = useRef(null)
  const popupRef = useRef(null)
  const [show, setShow] = useState(false)

  const start = value?.start || null
  const end = value?.end || null

  useEffect(() => {
    const handleOutside = (event) => {
      if (
        anchor.current && !anchor.current.contains(event.target) &&
        popupRef.current && !popupRef.current.contains(event.target)
      ) {
        setShow(false)
      }
    }
    document.addEventListener('mousedown', handleOutside)
    return () => document.removeEventListener('mousedown', handleOutside)
  }, [])

  const displayText = () => {
    if (!start && !end) return placeholder
    const formattedStart = start ? moment(start).format('HH:mm') : '…'
    const formattedEnd = end ? moment(end).format('HH:mm') : '…'
    return `${formattedStart} – ${formattedEnd}`
  }

  const hasValue = Boolean(start || end)

  return (
    <>
      <div
        className="range-picker-input"
        ref={anchor}
        onClick={() => setShow(prev => !prev)}
      >
        <span className={hasValue ? '' : 'range-picker-placeholder'}>{displayText()}</span>
        <SvgIcon icon={svgIcon['clockIcon']} />
      </div>
      <Popup anchor={anchor.current} show={show} popupClass="range-picker-popup">
        <div className="range-picker-time-popup" ref={popupRef}>
          <div className="range-picker-time-field">
            {labelStart && <label>{labelStart}</label>}
            <TimePicker
              value={start}
              onChange={(event) => onChange({ start: event.value, end })}
            />
          </div>
          <div className="range-picker-time-field">
            {labelEnd && <label>{labelEnd}</label>}
            <TimePicker
              value={end}
              onChange={(event) => onChange({ start, end: event.value })}
            />
          </div>
        </div>
      </Popup>
    </>
  )
}

export { RangeTimePickerHL as default }
